import React from "react";
import Component from "../../component/CustomerDetails";
const Dashboard = () => {
    return (
        <>
            <Component />
        </>
    )
}
export default Dashboard;